export function isSafariClipboardBrowser() {
  if (typeof navigator === 'undefined') return false

  const userAgent = navigator.userAgent || ''
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  const isWebKit = /AppleWebKit/i.test(userAgent)
  const isDesktopSafari = /Safari/i.test(userAgent) &&
    !/(Chrome|CriOS|FxiOS|Edg|EdgiOS|OPR|OPiOS|Opera|GSA)/i.test(userAgent)

  return isDesktopSafari || (isIOS && isWebKit)
}

export function copyTextWithExecCommand(text) {
  if (typeof document === 'undefined' || !document.body || typeof document.execCommand !== 'function') {
    return false
  }

  let textarea = null
  try {
    textarea = document.createElement('textarea')
    textarea.value = String(text ?? '')
    textarea.style.fontSize = '12pt'
    textarea.style.border = '0'
    textarea.style.padding = '0'
    textarea.style.margin = '0'
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px'
    const yPosition = typeof window !== 'undefined'
      ? (window.pageYOffset || document.documentElement?.scrollTop || 0)
      : 0
    textarea.style.top = `${yPosition}px`
    document.body.appendChild(textarea)
    textarea.select()
    if (typeof textarea.setSelectionRange === 'function') {
      textarea.setSelectionRange(0, textarea.value.length)
    }
    return document.execCommand('copy') === true
  } catch (error) {
    return false
  } finally {
    if (textarea?.parentNode) {
      textarea.parentNode.removeChild(textarea)
    }
  }
}

export async function writeTextToClipboard(text) {
  const value = String(text ?? '')
  if (!value) return false

  // Keep the first copy attempt synchronous so click-triggered callers retain
  // the browser's user-activation window for the native API if needed.
  if (copyTextWithExecCommand(value)) {
    return true
  }

  if (
    typeof navigator !== 'undefined' &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === 'function'
  ) {
    try {
      await navigator.clipboard.writeText(value)
      return true
    } catch (error) {
      return false
    }
  }

  return false
}

export default writeTextToClipboard
